<template>
  <div id="div-vue-app">
    <LayoutApp />
  </div>
</template>

<script setup lang="ts">
import "@/assets/css/global.css";
import "@/assets/css/fonts.css";
import "@/assets/css/quasarColorClasses.css";
import "@/assets/css/util.css";
import "@/assets/scss/layoutDefinitionClasses.scss";

import LayoutApp from '@/views/layout/LayoutApp.vue';

</script>

<style>

</style>
